<!-- components/Breadcrumb.vue -->
<template>
  <div class="text-xs">
    <span v-for="(crumb, index) in breadcrumbs" :key="crumb.path">
      <router-link v-if="index < breadcrumbs.length - 1" :to="crumb.path">
        {{ crumb.breadcrumb }}
      </router-link>

      <span v-else>{{ crumb.breadcrumb }}</span>

      <span v-if="index < breadcrumbs.length - 1"> &nbsp; > &nbsp;</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',

  computed: {
    breadcrumbs() {
      const matched = this.$route.matched

      // const breadcrumb = matched.map(route => route.meta.breadcrumb)
      return matched.flatMap((route) => {
        if (route.meta.breadcrumb) {
          return {
            path: route.path,
            breadcrumb: route.meta.breadcrumb || '',
          }
        } else {
          return []
        }
      })
    },
  },
}
</script>

<style scoped>
a {
  color: white;
  text-decoration: none;
}
</style>
